/**
 * Frontend-only visibility gate for the Sales Sequences (cadence) feature.
 *
 * IMPORTANT: this is NOT a security boundary. It only hides the Sequences
 * nav link, detail-modal tab, row action, /sequences + /today pages, and the
 * Slack morning brief from users who aren't part of the in-progress rollout —
 * so the UI isn't confusing for the rest of the team while we build it out.
 * The underlying tables, RLS, and APIs are not feature-gated here.
 *
 * To launch to everyone later: delete this file and its call sites (search for
 * `canUseSequences` / `useSequencesAccess` / `SEQUENCES_ALLOWED_EMAILS`).
 */
export const SEQUENCES_ALLOWED_EMAILS = [
  "miclainkeffeler@westtn.consulting",
  "miclain.keffeler@westtn.consulting",
  // Widened 2026-09-04 (Sep 9 webinar prep, Hub task c01e77e6 "open the send
  // gate past Miclain") — Miclain is traveling in Tokyo Sep 1-16 and was the
  // ONLY person who could see /sequences, /today, or the Slack morning
  // brief, so the newly-built webinar registrant sequence had no one to
  // actually work its queue while he's away. Added the other two WTC owners
  // rather than a single delegate, since either may need to cover it.
  "eliza.keffeler@westtn.consulting",
  "charlie.keffeler@westtn.consulting",
] as const;

/** True only for the hardcoded rollout allowlist. Email match is case-insensitive. */
export function canUseSequences(email: string | null | undefined): boolean {
  if (!email) return false;
  const normalized = email.trim().toLowerCase();
  return SEQUENCES_ALLOWED_EMAILS.some((allowed) => allowed === normalized);
}
